// extracted by mini-css-extract-plugin
export default {"flexRow":"ScenarioResults_flexRow__Fens7","flexCol":"ScenarioResults_flexCol__dCgJz"};